<li class="list-item btn">
  <h3 class="line-break">{{item.name}}</h3>
</li>
